<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix modal-heading">
      <span>Tremor Integration Settings</span>
      <el-button type="text" @click="$modal.hide('tracker-tremor-form')">
        <font-awesome-icon icon="window-close" fixed-width></font-awesome-icon>
      </el-button>
    </div>
    <el-form
      @submit.native.prevent="submit"
      :label-position="$root.windowWidth > 767 ? 'right' : 'top'"
      label-width="100px"
    >
      <el-form-item
        :error="form.errors.first('id') ? form.errors.first('id') : null"
        label="Advertiser"
        required
      >
        <modal-select>
          <el-select
            v-model="selected"
            :style="{ width: '100%' }"
            @focus="form.errors.clear('id')"
          >
            <el-option
              v-for="advertiser in advertisers"
              :key="advertiser.id"
              :label="advertiser.name"
              :value="advertiser.id"
            ></el-option>
          </el-select>
        </modal-select>
      </el-form-item>

      <el-form-item
        :error="
          form.errors.first('placement') ? form.errors.first('placement') : null
        "
        label="Filter"
      >
        <el-input
          v-model="placement"
          type="text"
          @focus="form.errors.clear('placement')"
        ></el-input>
        <p class="help-text">
          If given, this string will filter statistics to only placements
          containing this string. Use this to separate locations under the same
          advertiser.
        </p>
      </el-form-item>

      <el-button
        type="primary"
        plain
        medium
        native-type="submit"
        :style="{ width: '100%' }"
        v-loading="loading"
        :disabled="loading"
      >
        Submit
      </el-button>
    </el-form>
  </el-card>
</template>

<script>
import Form from "form-backend-validation"
import { mapActions, mapGetters } from "vuex"

export default {
  name: "TrackerTremorForm",
  props: {
    existing: {
      required: true,
    },
  },
  data() {
    return {
      advertisers: [],
      form: new Form(),
      selected: null,
      placement: "",
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      company: "companies/current",
    }),
    action() {
      return "tracker/" + this.company.slug + "/tremor/update"
    },
  },
  methods: {
    ...mapActions({
      updateCompany: "tracker/updateAdmin",
    }),
    submit() {
      this.loading = true

      let formData = {
        id: this.selected,
        placement: this.placement,
      }

      this.axios
        .post(this.action, formData)
        .then((response) => {
          this.updateCompany(response.data.data)
          this.$message.success(response.data.message)
          this.$modal.hide("tracker-tremor-form")
          this.loading = false
        })
        .catch((resp) => {
          this.loading = false
          if (resp.response && resp.response.status === 422) {
            this.form.onFail(resp)
          } else {
            this.$root.globalRequestError(resp)
          }
        })
    },
  },
  mounted() {
    this.loading = true
    this.axios
      .get("/tremor/advertisers")
      .then(({ data }) => {
        this.advertisers = data.data
        if (this.existing) {
          this.selected = this.existing.id
          this.placement = this.existing.filter || ""
        }
      })
      .finally(() => (this.loading = false))
  },
}
</script>

<style scoped lang="scss">
</style>
